export default __webpack_public_path__ + "static/media/analyst-view-v2.c0e71c42.svg";